import { render, staticRenderFns } from "./operateVideo.vue?vue&type=template&id=60a02ce8&scoped=true&"
import script from "./operateVideo.vue?vue&type=script&lang=js&"
export * from "./operateVideo.vue?vue&type=script&lang=js&"
import style0 from "./operateVideo.vue?vue&type=style&index=0&id=60a02ce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a02ce8",
  null
  
)

export default component.exports